// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"662":"selfdisclosure","941":"dbfrontend"}[chunkId] + "." + {"662":"a110afe2","941":"269aa827"}[chunkId] + ".css";
};